export enum BMEEmailTemplateName {
  ASK_DONOR_COMPLETE_FFQ = 'ASK_DONOR_COMPLETE_FFQ',
  NOTICE_DONOR_FFQ_COMPLETE = 'NOTICE_DONOR_FFQ_COMPLETE',
  REMIND_DONOR_SEND_OUT_KIT = 'REMIND_DONOR_SEND_OUT_KIT',
  REMIND_DONOR_SEND_OUT_KIT_TW0_WEEKS = 'REMIND_DONOR_SEND_OUT_KIT_TW0_WEEKS',
  ACTIVATION_INCOMPLETE_REMINDER_D31 = 'activationIncompleteReminderD31',
  SAMPLE_RECEIVED_AT_LAB_D2 = 'sampleReceivedAtLabD2',
  REPORT_READY_D4 = 'reportReadyD4',
  SAMPLE_RECEIVED_AT_LAB_B1 = 'sampleReceivedAtLabB1',
  REPORT_READY_B2 = 'reportReadyB2',
}
